import { Side, front, top, right, bottom, left, back } from 'src/constants/sides'

type Normal = [number, number, number]

export const getLookAt = (side: Side): Normal => {
  switch (side) {
    case front:
      return [0, 0, 1]
    case top:
      return [0, 1, 0]
    case right:
      return [1, 0, 0]
    case bottom:
      return [0, -1, 0]
    case left:
      return [-1, 0, 0]
    case back:
      return [0, 0, -1]
  }
}
